import DisabledTabs from './TabSet';
import { connect } from 'react-redux';
import { listsActions } from 'src/store/modules/lists';
import { IInitialState } from 'src/store/initialState';
import { isLoggedInSel } from 'src/store/modules/signin';
import actions from 'src/store/modules/arSummary/actions';
import invoiceActions from 'src/store/modules/invoices/actions';
import { contentSel } from 'src/store/modules/arSummary';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';

const mapStateToProps = (state: IInitialState) => ({
  isLoggedIn: isLoggedInSel(state),
  arSummaryData: contentSel(state)
});
const mapDispatchToProps = (dispatch: any) => ({
  getArSummary: () => dispatch(actions.getArSummary()),
  getInvoices: (
    filters: IFiltersInvoice,
    pagination: IPaginationInvoice,
    isHeader?: boolean
  ) => dispatch(invoiceActions.getInvoices(filters, pagination, isHeader))
});

export default connect(mapStateToProps, mapDispatchToProps)(DisabledTabs);

// interface IAccountViewProps {
//   getArSummary(): void;
//   getInvoices(): void;
// }
// export default DisabledTabs;
